import React from 'react';
import { cn } from '../utils';

export type SkeletonProps = React.HTMLAttributes<HTMLDivElement>;

export const Skeleton: React.FC<SkeletonProps> = ({ className, ...props }) => {
  return (
    <div
      className={cn(
        'animate-pulse rounded-md bg-surface-2/80 border border-border-subtle/30',
        className
      )}
      {...props}
    />
  );
};
